import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import AdminLayout from '../components/AdminLayout';

const API = process.env.NODE_ENV === 'production' ? '/api' : (process.env.REACT_APP_API_URL || '/api');
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

const SOURCE_META = {
  provider: { label: 'iGetTV',       color: '#22c55e' },
  relay:    { label: 'Premium4K',     color: '#3b82f6' },
  dxserver: { label: 'DXServer',     color: '#a855f7' },
  premier_services: { label: 'Premier Services', color: '#f97316' },
  dndns:    { label: 'StreamVision', color: '#ec4899' },
  mediamtx: { label: 'MediaMTX',     color: '#14b8a6' },
  unmapped: { label: 'AUTRES',       color: '#f59e0b' },
};
const CATEGORY_CREATION_SOURCES = Object.entries(SOURCE_META)
  .filter(([source]) => source !== 'mediamtx');
const srcMeta = (s) => SOURCE_META[s] || { label: s || '?', color: '#888' };
const normalize = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const inp = (ex = {}) => ({ width:'100%', padding:'9px 12px', borderRadius:8, border:'1px solid #334155', background:'#1e293b', color:'#e2e8f0', fontSize:13, outline:'none', boxSizing:'border-box', ...ex });
const selStyle = (ex = {}) => ({ padding:'10px 14px', borderRadius:8, border:'1px solid #334155', background:'#111827', color:'#e0e0e0', fontSize:13, cursor:'pointer', outline:'none', ...ex });

function Toast({ msg, ok, onClose }) {
  useEffect(() => { if (msg) { const t = setTimeout(onClose, 3000); return () => clearTimeout(t); } }, [msg, onClose]);
  if (!msg) return null;
  return (
    <div style={{ position:'fixed', top:20, right:20, zIndex:9999, padding:'12px 20px', borderRadius:10, background: ok ? '#16a34a' : '#dc2626', color:'#fff', fontSize:14, fontWeight:600, boxShadow:'0 4px 20px rgba(0,0,0,0.4)', display:'flex', alignItems:'center', gap:10 }}>
      {ok ? '✅' : '❌'} {msg}
      <button onClick={onClose} style={{ background:'none', border:'none', color:'#fff', cursor:'pointer', fontSize:16, lineHeight:1 }}>×</button>
    </div>
  );
}

function EditModal({ channel, categories, onSave, onClose }) {
  const [form, setForm] = useState({ ...channel });
  const [saving, setSaving] = useState(false);
  const [logoUploading, setLogoUploading] = useState(false);
  const [logoUploadError, setLogoUploadError] = useState('');
  const logoInput = useRef(null);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const handleLogoUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setLogoUploading(true);
    setLogoUploadError('');
    try {
      const body = new FormData();
      body.append('logo', file);
      const response = await fetch(`${API}/admin/channels-manager/channel-logos`, {
        method: 'POST',
        headers: auth(),
        body,
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Erreur lors de l’envoi du logo');
      set('stream_icon', data.logo_url);
    } catch (error) {
      setLogoUploadError(error.message);
    } finally {
      event.target.value = '';
      setLogoUploading(false);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const res = await fetch(`${API}/admin/channels-manager/channels/${form.id}`, {
        method:'PUT', headers:{ 'Content-Type':'application/json', ...auth() }, body:JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erreur');
      onSave(form);
    } catch (err) { alert('Erreur : ' + err.message); }
    finally { setSaving(false); }
  };
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }} onClick={onClose}>
      <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:14, padding:28, width:'100%', maxWidth:520, maxHeight:'90vh', overflowY:'auto' }} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin:'0 0 20px', fontSize:17, color:'#f1f5f9' }}>✏️ Modifier — {channel.name}</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {[['Nom *','name',true],['URL du stream *','stream_url',true],['EPG ID','epg_channel_id',false]].map(([label,key,req]) => (
              <div key={key}>
                <label style={{ display:'block', fontSize:12, color:'#94a3b8', marginBottom:4 }}>{label}</label>
                <input style={inp()} required={req} value={form[key]||''} onChange={e => set(key, e.target.value)} />
              </div>
            ))}
            <div>
              <label style={{ display:'block', fontSize:12, color:'#94a3b8', marginBottom:4 }}>Logo</label>
              <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
                <div style={{ width:46, height:46, flexShrink:0, borderRadius:6, overflow:'hidden', background:'#1e293b', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18 }}>
                  {form.stream_icon ? <img src={form.stream_icon} alt="" style={{ width:'100%', height:'100%', objectFit:'contain' }} onError={e => e.currentTarget.style.display='none'} /> : '📺'}
                </div>
                <input ref={logoInput} type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={handleLogoUpload} style={{ display:'none' }} />
                <button type="button" onClick={() => logoInput.current?.click()} disabled={logoUploading}
                  style={{ padding:'8px 12px', borderRadius:6, border:'1px solid #22c55e70', background:'#22c55e18', color:'#4ade80', cursor:logoUploading?'not-allowed':'pointer', fontSize:12, fontWeight:700, opacity:logoUploading?0.6:1 }}>
                  {logoUploading ? 'Envoi…' : 'Téléverser une image'}
                </button>
                <input style={inp({ flex:'1 1 190px' })} value={form.stream_icon||''} onChange={e => set('stream_icon', e.target.value)} placeholder="ou coller une URL de logo" />
              </div>
              {logoUploadError && <div style={{ marginTop:6, fontSize:11, color:'#f87171' }}>{logoUploadError}</div>}
            </div>
            <div>
              <label style={{ display:'block', fontSize:12, color:'#94a3b8', marginBottom:4 }}>Catégorie</label>
              <select style={inp()} value={form.category_id||''} onChange={e => set('category_id', e.target.value)}>
                <option value="">-- Choisir --</option>
                {categories.filter(c => !c.is_virtual).map(c => <option key={c.category_id} value={c.category_id}>[{srcMeta(c.source).label}] {c.category_name}</option>)}
              </select>
            </div>
            <div>
              <label style={{ display:'block', fontSize:12, color:'#94a3b8', marginBottom:4 }}>Statut</label>
              <select style={inp()} value={form.is_active??1} onChange={e => set('is_active', Number(e.target.value))}>
                <option value={1}>✅ Actif</option><option value={0}>🚫 Désactivé</option>
              </select>
            </div>
          </div>
          <div style={{ display:'flex', gap:10, marginTop:20, justifyContent:'flex-end' }}>
            <button type="button" onClick={onClose} style={{ padding:'9px 18px', borderRadius:8, border:'1px solid #334155', background:'transparent', color:'#94a3b8', cursor:'pointer', fontSize:13 }}>Annuler</button>
            <button type="submit" disabled={saving} style={{ padding:'9px 20px', borderRadius:8, border:'none', background:'#6366f1', color:'#fff', cursor:saving?'not-allowed':'pointer', fontSize:13, fontWeight:700, opacity:saving?0.7:1 }}>
              {saving ? '⏳…' : '💾 Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function AdminChannels() {
  const [allCategories, setAllCategories] = useState([]);  // toutes les catégories (incluant vides)
  const [channels,      setChannels]       = useState([]);
  const [loadingCats, setLoadingCats] = useState(true);
  const [loadingCh,   setLoadingCh]   = useState(false);
  const [selectedSource, setSelectedSource] = useState('');
  const [selectedCatId,  setSelectedCatId]  = useState('');
  const [searchCat, setSearchCat] = useState('');
  const [searchCh,  setSearchCh]  = useState('');
  const [editing,   setEditing]   = useState(null);
  const [deleting,  setDeleting]  = useState(null);
  const [selected,  setSelected]  = useState(new Set());
  const [bulkDel,   setBulkDel]   = useState(false);
  const [bulkDisable, setBulkDisable] = useState(false);
  const [bulkEnable, setBulkEnable] = useState(false);
  const [limit,     setLimit]     = useState(500);
  const [page,      setPage]      = useState(1);
  const [total,     setTotal]     = useState(0);
  const [totalPages,setTotalPages]= useState(1);
  const [toast,     setToast]     = useState(null);
  const channelRequest = useRef(null);
  // Créer catégorie
  const [showCreateCat, setShowCreateCat] = useState(false);
  const [newCatName,    setNewCatName]    = useState('');
  const [newCatSource,  setNewCatSource]  = useState('provider');
  const [creatingCat,   setCreatingCat]   = useState(false);
  // Modifier/Supprimer catégorie
  const [editingCat,    setEditingCat]    = useState(null);  // { category_id, category_name }
  const [editCatName,   setEditCatName]   = useState('');
  const [savingCat,     setSavingCat]     = useState(false);
  const [deletingCat,   setDeletingCat]   = useState(false);
  // Ajouter chaînes depuis d'autres catégories
  const [showAddPanel, setShowAddPanel] = useState(false);
  const [addSearch,    setAddSearch]    = useState('');
  const [addCatFilter, setAddCatFilter] = useState('');
  const [addResults,   setAddResults]   = useState([]);
  const [loadingAdd,   setLoadingAdd]   = useState(false);
  const [addSelected,  setAddSelected]  = useState(new Set());
  const [moving,       setMoving]       = useState(false);

  // ── Charger TOUTES les catégories (y compris vides) via /live-categories ──
  const loadCategories = useCallback(async () => {
    setLoadingCats(true);
    try {
      const res = await fetch(`${API}/admin/channels-manager/live-categories`, { headers: auth() });
      const data = await res.json();
      setAllCategories(data.categories || []);
    } catch { setAllCategories([]); }
    finally { setLoadingCats(false); }
  }, []);

  useEffect(() => { loadCategories(); }, [loadCategories]);

  // ── Charger chaînes de la catégorie sélectionnée ──
  const loadChannels = useCallback(async (catId, src, lim, requestedPage, term) => {
    if (!catId) {
      channelRequest.current?.abort();
      setChannels([]); setTotal(0); setTotalPages(1);
      return;
    }
    channelRequest.current?.abort();
    const controller = new AbortController();
    channelRequest.current = controller;
    setLoadingCh(true);
    try {
      const params = new URLSearchParams({
        category: catId,
        limit: String(lim || 500),
        page: String(requestedPage || 1)
      });
      if (src) params.set('source', src);
      if (term?.trim()) params.set('search', term.trim());
      const res = await fetch(`${API}/admin/channels-manager/channels?${params}`, {
        headers: auth(), signal: controller.signal
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erreur de chargement');
      setChannels(data.channels || []);
      setTotal(Number(data.total) || 0);
      setTotalPages(Math.max(1, Number(data.totalPages) || 1));
      if (Number(data.page) && Number(data.page) !== requestedPage) setPage(Number(data.page));
    } catch (error) {
      if (error.name !== 'AbortError') {
        setChannels([]); setTotal(0); setTotalPages(1);
      }
    } finally {
      if (channelRequest.current === controller) setLoadingCh(false);
    }
  }, []);

  const selectedCat = useMemo(() => allCategories.find(c => c.category_id === selectedCatId), [allCategories, selectedCatId]);

  useEffect(() => {
    const delay = searchCh.trim() ? 300 : 0;
    const timer = setTimeout(
      () => loadChannels(selectedCatId, selectedCat?.source, limit, page, searchCh),
      delay
    );
    return () => clearTimeout(timer);
  }, [selectedCatId, selectedCat?.source, limit, page, searchCh, loadChannels]);

  useEffect(() => () => channelRequest.current?.abort(), []);

  // ── Dériver les listes ──
  const sources = useMemo(() => [...new Set(allCategories.map(c => c.source).filter(Boolean))].sort(), [allCategories]);

  const filteredCats = useMemo(() => {
    let list = selectedSource ? allCategories.filter(c => c.source === selectedSource) : allCategories;
    if (searchCat.trim()) { const s = normalize(searchCat); list = list.filter(c => normalize(c.category_name).includes(s)); }
    return list;
  }, [allCategories, selectedSource, searchCat]);

  const filteredCh = channels;

  const selectedStatus = useMemo(() => {
    let active = 0;
    let inactive = 0;
    for (const channel of channels) {
      if (!selected.has(channel.id)) continue;
      if (Number(channel.is_active) === 0) inactive += 1;
      else active += 1;
    }
    return { active, inactive };
  }, [channels, selected]);

  // ── Recherche globale pour ajouter des chaînes ──
  const searchGlobalChannels = useCallback(async (term, catId) => {
    if (!term.trim() && !catId) { setAddResults([]); return; }
    setLoadingAdd(true);
    try {
      const params = new URLSearchParams({ limit: 100 });
      if (term.trim()) params.set('search', term);
      if (catId) params.set('category', catId);
      const res = await fetch(`${API}/admin/channels-manager/channels?${params}`, { headers: auth() });
      const data = await res.json();
      // Exclure les chaînes déjà dans la catégorie courante
      const currentIds = new Set(channels.map(c => c.id));
      setAddResults((data.channels || []).filter(c => !currentIds.has(c.id)));
    } catch { setAddResults([]); }
    finally { setLoadingAdd(false); }
  }, [channels]);

  useEffect(() => {
    if (!showAddPanel) return;
    const t = setTimeout(() => searchGlobalChannels(addSearch, addCatFilter), 300);
    return () => clearTimeout(t);
  }, [addSearch, addCatFilter, showAddPanel, searchGlobalChannels]);

  // ── Stats ──
  const stats = useMemo(() => ({
    total: allCategories.length,
    totalCh: allCategories.reduce((s, c) => s + (c.count||0), 0),
  }), [allCategories]);

  // ── Actions ──
  const handleDelete = async (ch) => {
    if (!window.confirm(`Supprimer "${ch.name}" ?`)) return;
    setDeleting(ch.id);
    try {
      const res = await fetch(`${API}/admin/channels-manager/channels/${ch.id}`, { method:'DELETE', headers:auth() });
      if (!res.ok) throw new Error();
      setChannels(prev => prev.map(c => c.id === ch.id ? { ...c, is_active: 0 } : c));
      setTotal(prev => Math.max(0, prev - 1));
      setAllCategories(prev => prev.map(c => c.category_id === selectedCatId ? { ...c, count: Math.max(0,(c.count||0)-1) } : c));
      setToast({ msg:'Chaîne désactivée', ok:true });
    } catch { setToast({ msg:'Erreur suppression', ok:false }); }
    finally { setDeleting(null); }
  };

  const handleBulkDelete = async () => {
    if (!selected.size || !window.confirm(`Supprimer ${selected.size} chaîne${selected.size>1?'s':''} ?`)) return;
    setBulkDel(true);
    try {
      const ids = [...selected];
      const res = await fetch(`${API}/admin/channels-manager/channels`, {
        method:'DELETE', headers:{ 'Content-Type':'application/json', ...auth() }, body:JSON.stringify({ ids })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setChannels(prev => prev.map(c => selected.has(c.id) ? { ...c, is_active: 0 } : c));
      setTotal(prev => Math.max(0, prev - (data.deleted || 0)));
      setAllCategories(prev => prev.map(c => c.category_id === selectedCatId ? { ...c, count: Math.max(0,(c.count||0)-ids.length) } : c));
      setSelected(new Set());
      setToast({ msg:`${data.deleted} chaîne${data.deleted>1?'s':''} désactivée${data.deleted>1?'s':''}`, ok:true });
    } catch (err) { setToast({ msg:'Erreur: '+err.message, ok:false }); }
    finally { setBulkDel(false); }
  };

  const handleBulkDisable = async () => {
    if (!selected.size || !window.confirm(`Désactiver ${selected.size} chaîne${selected.size > 1 ? 's' : ''} ?`)) return;
    setBulkDisable(true);
    try {
      const ids = [...selected];
      const res = await fetch(`${API}/admin/channels-manager/channels/status`, {
        method:'PATCH', headers:{ 'Content-Type':'application/json', ...auth() },
        body:JSON.stringify({ ids, is_active: 0 })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erreur');
      setChannels(prev => prev.map(c => selected.has(c.id) ? { ...c, is_active: 0 } : c));
      setAllCategories(prev => prev.map(c => (
        c.category_id === selectedCatId && c.source === selectedCat?.source
          ? { ...c, count: Math.max(0, (c.count || 0) - (data.updated || 0)) }
          : c
      )));
      setSelected(new Set());
      setToast({ msg:`${data.updated} chaîne${data.updated > 1 ? 's' : ''} désactivée${data.updated > 1 ? 's' : ''}`, ok:true });
    } catch (err) { setToast({ msg:'Erreur: ' + err.message, ok:false }); }
    finally { setBulkDisable(false); }
  };

  const handleBulkEnable = async () => {
    if (!selectedStatus.inactive || !window.confirm(`Activer ${selectedStatus.inactive} chaîne${selectedStatus.inactive > 1 ? 's' : ''} ?`)) return;
    setBulkEnable(true);
    try {
      const ids = [...selected];
      const res = await fetch(`${API}/admin/channels-manager/channels/status`, {
        method:'PATCH', headers:{ 'Content-Type':'application/json', ...auth() },
        body:JSON.stringify({ ids, is_active: 1 })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erreur');
      setChannels(prev => prev.map(c => selected.has(c.id) ? { ...c, is_active: 1 } : c));
      setAllCategories(prev => prev.map(c => (
        c.category_id === selectedCatId && c.source === selectedCat?.source
          ? { ...c, count: (c.count || 0) + (data.updated || 0) }
          : c
      )));
      setSelected(new Set());
      setToast({ msg:`${data.updated} chaîne${data.updated > 1 ? 's' : ''} activée${data.updated > 1 ? 's' : ''}`, ok:true });
    } catch (err) { setToast({ msg:'Erreur: ' + err.message, ok:false }); }
    finally { setBulkEnable(false); }
  };

  const handleSaved = () => {
    setEditing(null);
    loadChannels(selectedCatId, selectedCat?.source, limit, page, searchCh);
    loadCategories();
    setToast({ msg:'Chaîne mise à jour', ok:true });
  };

  const handleCreateCategory = async () => {
    if (!newCatName.trim()) return;
    setCreatingCat(true);
    try {
      const res = await fetch(`${API}/admin/channels-manager/live-categories`, {
        method:'POST', headers:{ 'Content-Type':'application/json', ...auth() },
        body:JSON.stringify({ category_name: newCatName.trim(), source: newCatSource })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      await loadCategories();
      setNewCatName(''); setShowCreateCat(false);
      setToast({ msg:`Catégorie "${data.category_name}" créée`, ok:true });
    } catch (err) { setToast({ msg:'Erreur: '+err.message, ok:false }); }
    finally { setCreatingCat(false); }
  };

  const handleRenameCategory = async () => {
    if (!editCatName.trim() || !editingCat) return;
    setSavingCat(true);
    try {
      const q = editingCat?.source ? `?source=${encodeURIComponent(editingCat.source)}` : '';
      const res = await fetch(`${API}/admin/channels-manager/live-categories/${encodeURIComponent(editingCat.category_id)}${q}`, {
        method:'PUT', headers:{ 'Content-Type':'application/json', ...auth() },
        body:JSON.stringify({ category_name: editCatName.trim() })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setAllCategories(prev => prev.map(c => c.category_id === editingCat.category_id ? { ...c, category_name: editCatName.trim() } : c));
      setEditingCat(null);
      setToast({ msg:'Catégorie renommée', ok:true });
    } catch (err) { setToast({ msg:'Erreur: '+err.message, ok:false }); }
    finally { setSavingCat(false); }
  };

  const handleDeleteCategory = async (withChannels) => {
    if (!selectedCat) return;
    const count = selectedCat.count || 0;
    const msg = withChannels
      ? `Supprimer la catégorie "${selectedCat.category_name}" ET ses ${count} chaînes ?`
      : `Supprimer la catégorie "${selectedCat.category_name}" (les ${count} chaînes seront orphelines) ?`;
    if (!window.confirm(msg)) return;
    setDeletingCat(true);
    try {
      const q = new URLSearchParams({
        delete_channels: withChannels ? 'true' : 'false',
        source: selectedCat?.source || ''
      });
      const res = await fetch(`${API}/admin/channels-manager/live-categories/${encodeURIComponent(selectedCatId)}?${q.toString()}`, {
        method:'DELETE', headers:auth()
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSelectedCatId('');
      await loadCategories();
      setToast({ msg:`Catégorie "${data.category_name}" supprimée`, ok:true });
    } catch (err) { setToast({ msg:'Erreur: '+err.message, ok:false }); }
    finally { setDeletingCat(false); }
  };

  // Ajouter les chaînes sélectionnées dans la catégorie courante
  const handleAddToCurrent = async () => {
    if (!addSelected.size || !selectedCatId) return;
    setMoving(true);
    try {
      const ids = [...addSelected];
      const res = await fetch(`${API}/admin/channels-manager/channels/move`, {
        method:'PUT', headers:{ 'Content-Type':'application/json', ...auth() },
        body:JSON.stringify({ ids, target_category_id: selectedCatId })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      // Recharger les chaînes de la catégorie courante
      await loadChannels(selectedCatId, selectedCat?.source, limit, page, searchCh);
      await loadCategories();
      setAddResults(prev => prev.filter(c => !addSelected.has(c.id)));
      setAddSelected(new Set());
      setToast({ msg:`${data.moved} chaîne${data.moved>1?'s':''} ajoutée${data.moved>1?'s':''} à la catégorie`, ok:true });
    } catch (err) { setToast({ msg:'Erreur: '+err.message, ok:false }); }
    finally { setMoving(false); }
  };

  const toggleSel = (id) => setSelected(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const toggleAdd = (id) => setAddSelected(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });

  return (
    <AdminLayout>
      <div style={{ padding:24, color:'#e0e0e0', minHeight:'100vh', background:'#0f0f1a' }}>

        {/* Titre */}
        <div style={{ marginBottom:20 }}>
          <h1 style={{ fontSize:22, fontWeight:700, margin:0, color:'#fff' }}>📺 Gestion des Chaînes</h1>
          <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Choisissez un provider et une catégorie pour gérer les chaînes.</p>
        </div>

        {/* Stats rapides */}
        <div style={{ display:'flex', gap:10, marginBottom:20, flexWrap:'wrap' }}>
          <div style={{ background:'#111827', borderRadius:10, padding:'12px 18px', border:'1px solid #1e293b', flex:'1 1 130px' }}>
            <div style={{ fontSize:22, fontWeight:800, color:'#6366f1' }}>{stats.total}</div>
            <div style={{ fontSize:11, color:'#64748b', marginTop:2 }}>Catégories</div>
          </div>
          <div style={{ background:'#111827', borderRadius:10, padding:'12px 18px', border:'1px solid #1e293b', flex:'1 1 130px' }}>
            <div style={{ fontSize:22, fontWeight:800, color:'#f59e0b' }}>{stats.totalCh.toLocaleString()}</div>
            <div style={{ fontSize:11, color:'#64748b', marginTop:2 }}>Chaînes totales</div>
          </div>
          {Object.entries(SOURCE_META).map(([src, meta]) => {
            const n = allCategories.filter(c => c.source===src).length;
            const ch = allCategories.filter(c => c.source===src).reduce((s,c) => s+(c.count||0), 0);
            return (
              <div key={src} style={{ background:'#111827', borderRadius:10, padding:'12px 18px', border:'1px solid #1e293b', borderTop:`3px solid ${meta.color}`, flex:'1 1 130px' }}>
                <div style={{ fontSize:22, fontWeight:800, color:meta.color }}>{n}</div>
                <div style={{ fontSize:11, color:'#64748b', marginTop:2 }}>{meta.label} · {ch.toLocaleString()} ch.</div>
              </div>
            );
          })}
        </div>

        {/* ── Sélecteurs ── */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:20, maxWidth:900 }}>

          {/* Provider */}
          <div style={{ background:'#111827', borderRadius:12, padding:18, border:'1px solid #1e293b' }}>
            <label style={{ display:'block', fontSize:12, color:'#94a3b8', marginBottom:8, fontWeight:600, textTransform:'uppercase', letterSpacing:'0.05em' }}>🌐 Provider</label>
            <select value={selectedSource} onChange={e => { setSelectedSource(e.target.value); setSelectedCatId(''); setSearchCat(''); }}
              style={selStyle({ width:'100%' })}>
              <option value="">— Tous ({allCategories.length}) —</option>
              {sources.map(src => { const m = srcMeta(src); return <option key={src} value={src}>{m.label} ({allCategories.filter(c => c.source===src).length})</option>; })}
            </select>
            {selectedSource && (
              <div style={{ marginTop:8, padding:'6px 10px', borderRadius:6, background:`${srcMeta(selectedSource).color}15`, border:`1px solid ${srcMeta(selectedSource).color}40`, fontSize:11, color:srcMeta(selectedSource).color }}>
                ✓ {srcMeta(selectedSource).label} · {filteredCats.length} catégories
              </div>
            )}
          </div>

          {/* Catégorie */}
          <div style={{ background:'#111827', borderRadius:12, padding:18, border:'1px solid #1e293b' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
              <label style={{ fontSize:12, color:'#94a3b8', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.05em' }}>📁 Catégorie</label>
              <button onClick={() => setShowCreateCat(v => !v)}
                style={{ padding:'4px 10px', borderRadius:6, border:'1px solid #6366f150', background: showCreateCat ? '#6366f130' : '#6366f118', color:'#818cf8', cursor:'pointer', fontSize:11, fontWeight:700 }}>
                ➕ Nouvelle catégorie
              </button>
            </div>

            {/* Formulaire création */}
            {showCreateCat && (
              <div style={{ marginBottom:10, padding:12, borderRadius:8, background:'#1e293b', border:'1px solid #6366f140' }}>
                <div style={{ fontSize:12, color:'#818cf8', marginBottom:8, fontWeight:700 }}>➕ Créer une catégorie</div>
                <input value={newCatName} onChange={e => setNewCatName(e.target.value)}
                  onKeyDown={e => { if (e.key==='Enter') handleCreateCategory(); }}
                  placeholder="Nom de la catégorie…"
                  style={inp({ marginBottom:8, fontSize:12, padding:'8px 10px' })} />
                <div style={{ display:'flex', gap:5, marginBottom:8, flexWrap:'wrap' }}>
                  {CATEGORY_CREATION_SOURCES.map(([src, meta]) => (
                    <button key={src} onClick={() => setNewCatSource(src)}
                      style={{ flex:'1 1 105px', padding:'5px 8px', borderRadius:6, border:`1px solid ${newCatSource===src ? meta.color : '#334155'}`, background: newCatSource===src ? `${meta.color}25` : 'transparent', color: newCatSource===src ? meta.color : '#94a3b8', cursor:'pointer', fontSize:11, fontWeight:600 }}>
                      {meta.label}
                    </button>
                  ))}
                </div>
                <div style={{ display:'flex', gap:6 }}>
                  <button onClick={handleCreateCategory} disabled={creatingCat || !newCatName.trim()}
                    style={{ flex:1, padding:'7px 0', borderRadius:6, border:'none', background:'#6366f1', color:'#fff', cursor: (creatingCat||!newCatName.trim())?'not-allowed':'pointer', fontSize:12, fontWeight:700, opacity:(creatingCat||!newCatName.trim())?0.5:1 }}>
                    {creatingCat ? '⏳…' : '✅ Créer'}
                  </button>
                  <button onClick={() => { setShowCreateCat(false); setNewCatName(''); }}
                    style={{ padding:'7px 14px', borderRadius:6, border:'1px solid #475569', background:'transparent', color:'#94a3b8', cursor:'pointer', fontSize:12 }}>
                    Annuler
                  </button>
                </div>
              </div>
            )}

            <div style={{ display:'flex', gap:8, marginBottom:8 }}>
              <input value={searchCat} onChange={e => setSearchCat(e.target.value)} placeholder="🔍 Filtrer…"
                style={selStyle({ flex:1, padding:'8px 12px' })} />
              {searchCat && <button onClick={() => setSearchCat('')} style={{ padding:'8px 12px', borderRadius:8, border:'1px solid #475569', background:'transparent', color:'#94a3b8', cursor:'pointer', fontSize:12 }}>✕</button>}
            </div>
            <select value={selectedCatId} onChange={e => {
                setSelectedCatId(e.target.value);
                setPage(1); setSearchCh(''); setSelected(new Set());
                setShowAddPanel(false); setAddResults([]); setAddSelected(new Set());
              }} disabled={loadingCats}
              style={selStyle({ width:'100%' })} size={6}>
              <option value="">— Choisir une catégorie —</option>
              {filteredCats.map(cat => {
                const m = srcMeta(cat.source);
                const empty = (cat.count||0) === 0;
                return (
                  <option key={`${cat.source}:${cat.category_id}`} value={cat.category_id}>
                    {empty ? '○ ' : '● '}[{m.label}] {cat.category_name} ({cat.count||0})
                  </option>
                );
              })}
            </select>
            <div style={{ marginTop:6, fontSize:11, color:'#475569' }}>
              {loadingCats ? '⏳ Chargement…' : `${filteredCats.length} catégorie${filteredCats.length!==1?'s':''}  —  ● = contient des chaînes  ○ = vide`}
            </div>
          </div>
        </div>

        {/* ── Panneau chaînes ── */}
        {selectedCatId ? (
          <div style={{ background:'#111827', borderRadius:12, border:'1px solid #1e293b', overflow:'hidden' }}>

            {/* Header */}
            <div style={{ padding:'14px 18px', background:'#0f172a', borderBottom:'1px solid #1e293b', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:10 }}>
              <div>
                <div style={{ fontSize:15, fontWeight:700, color:'#f1f5f9' }}>
                  📺 {selectedCat?.category_name || '…'}
                  {selectedCat && <span style={{ marginLeft:8, padding:'2px 8px', borderRadius:999, background:`${srcMeta(selectedCat.source).color}20`, color:srcMeta(selectedCat.source).color, border:`1px solid ${srcMeta(selectedCat.source).color}40`, fontSize:11, fontWeight:600 }}>{srcMeta(selectedCat.source).label}</span>}
                  {/* Une catégorie virtuelle est une vue calculée, pas une ligne modifiable. */}
                  {!selectedCat?.is_virtual && <>
                    <button onClick={() => { setEditingCat(selectedCat); setEditCatName(selectedCat?.category_name || ''); }}
                      style={{ marginLeft:10, padding:'3px 8px', borderRadius:5, border:'1px solid #6366f150', background:'#6366f118', color:'#818cf8', cursor:'pointer', fontSize:11, verticalAlign:'middle' }}>
                      ✏️ Renommer
                    </button>
                    <button onClick={() => setDeletingCat('confirm')} disabled={deletingCat === true}
                      style={{ marginLeft:6, padding:'3px 8px', borderRadius:5, border:'1px solid #ef444450', background:'#ef444418', color:'#f87171', cursor:'pointer', fontSize:11, verticalAlign:'middle' }}>
                      🗑️ Supprimer
                    </button>
                  </>}
                </div>

                {/* Modal renommer */}
                {editingCat && editingCat.category_id === selectedCatId && (
                  <div style={{ marginTop:8, display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                    <input value={editCatName} onChange={e => setEditCatName(e.target.value)}
                      onKeyDown={e => { if (e.key==='Enter') handleRenameCategory(); if (e.key==='Escape') setEditingCat(null); }}
                      autoFocus
                      style={{ padding:'7px 12px', borderRadius:7, border:'1px solid #6366f1', background:'#1e293b', color:'#e2e8f0', fontSize:13, outline:'none', flex:'1 1 200px', minWidth:150 }} />
                    <button onClick={handleRenameCategory} disabled={savingCat || !editCatName.trim()}
                      style={{ padding:'7px 14px', borderRadius:7, border:'none', background:'#6366f1', color:'#fff', cursor:(savingCat||!editCatName.trim())?'not-allowed':'pointer', fontSize:12, fontWeight:700, opacity:(savingCat||!editCatName.trim())?0.6:1 }}>
                      {savingCat ? '⏳…' : '✅ Enregistrer'}
                    </button>
                    <button onClick={() => setEditingCat(null)}
                      style={{ padding:'7px 12px', borderRadius:7, border:'1px solid #475569', background:'transparent', color:'#94a3b8', cursor:'pointer', fontSize:12 }}>
                      Annuler
                    </button>
                  </div>
                )}

                {/* Confirmation suppression catégorie */}
                {deletingCat === 'confirm' && (
                  <div style={{ marginTop:8, padding:'10px 14px', borderRadius:8, background:'#ef444415', border:'1px solid #ef444460', display:'flex', gap:8, flexWrap:'wrap', alignItems:'center' }}>
                    <span style={{ fontSize:12, color:'#fca5a5', flex:1 }}>
                      Supprimer « {selectedCat?.category_name} » ({selectedCat?.count || 0} chaînes) :
                    </span>
                    <button onClick={() => handleDeleteCategory(false)}
                      style={{ padding:'6px 12px', borderRadius:6, border:'1px solid #f87171', background:'transparent', color:'#f87171', cursor:'pointer', fontSize:11, fontWeight:600 }}>
                      Catégorie seulement
                    </button>
                    <button onClick={() => handleDeleteCategory(true)}
                      style={{ padding:'6px 12px', borderRadius:6, border:'none', background:'#ef4444', color:'#fff', cursor:'pointer', fontSize:11, fontWeight:700 }}>
                      + Supprimer les {selectedCat?.count || 0} chaînes
                    </button>
                    <button onClick={() => setDeletingCat(false)}
                      style={{ padding:'6px 10px', borderRadius:6, border:'1px solid #475569', background:'transparent', color:'#94a3b8', cursor:'pointer', fontSize:11 }}>
                      Annuler
                    </button>
                  </div>
                )}
                <div style={{ fontSize:12, color:'#64748b', marginTop:3 }}>
                  {loadingCh ? '⏳' : `${channels.length} affichées sur ${total.toLocaleString()}`}
                  {selected.size > 0 && <span style={{ marginLeft:8, color:'#f59e0b', fontWeight:600 }}>· {selected.size} sélectionnée{selected.size>1?'s':''}</span>}
                </div>
              </div>
              <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'center' }}>
                {/* Sélecteur de limite */}
                <select value={limit} onChange={e => { setLimit(Number(e.target.value)); setPage(1); }}
                  style={{ padding:'5px 10px', borderRadius:6, border:'1px solid #334155', background:'#1e293b', color:'#94a3b8', fontSize:12, cursor:'pointer' }}
                  title="Nombre de chaînes à afficher">
                  {[50, 100, 200, 500, 1000].map(n => (
                    <option key={n} value={n}>{n === 1000 ? 'Tout (1000)' : `${n} chaînes`}</option>
                  ))}
                </select>
                {/* Sélection */}
                {!loadingCh && filteredCh.length > 0 && (
                  <>
                    <button onClick={() => setSelected(new Set(filteredCh.map(c => c.id)))}
                      style={{ padding:'6px 11px', borderRadius:6, border:'1px solid #475569', background:'transparent', color:'#94a3b8', cursor:'pointer', fontSize:11 }}>☑ Tout</button>
                    <button onClick={() => setSelected(new Set())} disabled={!selected.size}
                      style={{ padding:'6px 11px', borderRadius:6, border:'1px solid #475569', background:'transparent', color:'#94a3b8', cursor:selected.size?'pointer':'not-allowed', fontSize:11, opacity:selected.size?1:0.4 }}>✕ Désel.</button>
                  </>
                )}
                {selectedStatus.inactive > 0 && (
                  <button onClick={handleBulkEnable} disabled={bulkEnable}
                    style={{ padding:'6px 14px', borderRadius:6, border:'1px solid #22c55e', background:'#22c55e20', color:'#4ade80', cursor:bulkEnable?'not-allowed':'pointer', fontSize:12, fontWeight:700 }}>
                    {bulkEnable ? '⏳…' : `✅ Activer (${selectedStatus.inactive})`}
                  </button>
                )}
                {selectedStatus.active > 0 && (
                  <button onClick={handleBulkDisable} disabled={bulkDisable}
                    style={{ padding:'6px 14px', borderRadius:6, border:'1px solid #f59e0b', background:'#f59e0b20', color:'#fbbf24', cursor:bulkDisable?'not-allowed':'pointer', fontSize:12, fontWeight:700 }}>
                    {bulkDisable ? '⏳…' : `🚫 Désactiver (${selectedStatus.active})`}
                  </button>
                )}
                {selected.size > 0 && (
                  <button onClick={handleBulkDelete} disabled={bulkDel}
                    style={{ padding:'6px 14px', borderRadius:6, border:'1px solid #ef4444', background:'#ef444420', color:'#f87171', cursor:bulkDel?'not-allowed':'pointer', fontSize:12, fontWeight:700 }}>
                    {bulkDel ? '⏳…' : `🗑️ Supprimer (${selected.size})`}
                  </button>
                )}
                {/* Bouton Ajouter des chaînes */}
                {!selectedCat?.is_virtual && <button onClick={() => { setShowAddPanel(v => !v); setAddSearch(''); setAddCatFilter(''); setAddResults([]); setAddSelected(new Set()); }}
                  style={{ padding:'6px 14px', borderRadius:6, border:`1px solid ${showAddPanel ? '#22c55e' : '#334155'}`, background: showAddPanel ? '#22c55e20' : '#1e293b', color: showAddPanel ? '#22c55e' : '#94a3b8', cursor:'pointer', fontSize:12, fontWeight:700 }}>
                  ➕ Ajouter des chaînes
                </button>}
                <input value={searchCh} onChange={e => { setSearchCh(e.target.value); setPage(1); }} placeholder="🔍 Rechercher nom, URL ou ID…"
                  style={{ padding:'8px 14px', borderRadius:8, border:'1px solid #334155', background:'#1e293b', color:'#e0e0e0', fontSize:13, outline:'none', width:200 }} />
              </div>
            </div>

            {/* ── Panneau "Ajouter des chaînes depuis d'autres catégories" ── */}
            {showAddPanel && (
              <div style={{ padding:'16px 18px', background:'#0f1e14', borderBottom:'1px solid #22c55e30' }}>
                <div style={{ fontSize:13, fontWeight:700, color:'#22c55e', marginBottom:12 }}>
                  ➕ Ajouter des chaînes existantes dans « {selectedCat?.category_name} »
                </div>
                <div style={{ display:'flex', gap:8, marginBottom:12, flexWrap:'wrap' }}>
                  <input value={addSearch} onChange={e => setAddSearch(e.target.value)} placeholder="🔍 Rechercher une chaîne par nom ou URL…"
                    style={inp({ flex:'1 1 250px', fontSize:12, padding:'8px 12px' })} />
                  <select value={addCatFilter} onChange={e => setAddCatFilter(e.target.value)}
                    style={selStyle({ flex:'1 1 220px', fontSize:12 })}>
                    <option value="">— Toutes les catégories —</option>
                    {allCategories.filter(c => !c.is_virtual && c.category_id !== selectedCatId && (c.count||0) > 0).map(cat => (
                      <option key={cat.category_id} value={cat.category_id}>[{srcMeta(cat.source).label}] {cat.category_name} ({cat.count})</option>
                    ))}
                  </select>
                </div>

                {/* Résultats */}
                <div style={{ maxHeight:300, overflowY:'auto', border:'1px solid #1e3a2e', borderRadius:8, background:'#0a1a0f' }}>
                  {loadingAdd ? (
                    <div style={{ padding:30, textAlign:'center', color:'#64748b' }}>⏳ Recherche…</div>
                  ) : addResults.length === 0 ? (
                    <div style={{ padding:30, textAlign:'center', color:'#475569', fontSize:13 }}>
                      {addSearch || addCatFilter ? 'Aucun résultat — tapez un nom ou choisissez une catégorie' : 'Tapez un nom de chaîne ou choisissez une catégorie source'}
                    </div>
                  ) : addResults.map((ch, i) => (
                    <div key={ch.id} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 14px', borderBottom:'1px solid #1e3a2e30', background: addSelected.has(ch.id) ? '#22c55e12' : i%2===0 ? 'transparent' : '#0f1a0f', borderLeft: addSelected.has(ch.id) ? '3px solid #22c55e' : '3px solid transparent' }}>
                      <input type="checkbox" checked={addSelected.has(ch.id)} onChange={() => toggleAdd(ch.id)}
                        style={{ width:16, height:16, accentColor:'#22c55e', cursor:'pointer', flexShrink:0 }} />
                      <div style={{ width:28, height:28, flexShrink:0, borderRadius:5, overflow:'hidden', background:'#1e293b', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12 }}>
                        {ch.stream_icon ? <img src={ch.stream_icon} alt="" style={{ width:'100%', height:'100%', objectFit:'contain' }} onError={e => e.target.style.display='none'} /> : '📺'}
                      </div>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ fontSize:12, color:'#e2e8f0', fontWeight:500, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{ch.name}</div>
                        <div style={{ fontSize:10, color:'#475569', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                          {ch.category_name} · {ch.stream_url}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Actions ajout */}
                <div style={{ display:'flex', gap:8, marginTop:10, alignItems:'center' }}>
                  {addResults.length > 0 && (
                    <>
                      <button onClick={() => setAddSelected(new Set(addResults.map(c => c.id)))}
                        style={{ padding:'6px 11px', borderRadius:6, border:'1px solid #22c55e50', background:'#22c55e18', color:'#22c55e', cursor:'pointer', fontSize:11, fontWeight:600 }}>
                        ☑ Tout sélectionner ({addResults.length})
                      </button>
                      <button onClick={() => setAddSelected(new Set())} disabled={!addSelected.size}
                        style={{ padding:'6px 11px', borderRadius:6, border:'1px solid #475569', background:'transparent', color:'#94a3b8', cursor:addSelected.size?'pointer':'not-allowed', fontSize:11, opacity:addSelected.size?1:0.4 }}>
                        ✕ Désel.
                      </button>
                    </>
                  )}
                  {addSelected.size > 0 && (
                    <button onClick={handleAddToCurrent} disabled={moving}
                      style={{ padding:'7px 18px', borderRadius:7, border:'none', background:'#22c55e', color:'#000', cursor:moving?'not-allowed':'pointer', fontSize:13, fontWeight:800, opacity:moving?0.6:1, marginLeft:'auto' }}>
                      {moving ? '⏳…' : `✅ Ajouter ${addSelected.size} chaîne${addSelected.size>1?'s':''} ici`}
                    </button>
                  )}
                </div>
              </div>
            )}

            {/* Liste chaînes actuelles */}
            <div style={{ maxHeight:'50vh', overflowY:'auto' }}>
              {loadingCh ? (
                <div style={{ padding:40, textAlign:'center', color:'#64748b' }}>⏳ Chargement…</div>
              ) : filteredCh.length === 0 ? (
                <div style={{ padding:40, textAlign:'center', color:'#64748b' }}>
                  {searchCh ? 'Aucun résultat' : (
                    <div>
                      <div style={{ fontSize:30, marginBottom:8 }}>📭</div>
                      <div style={{ fontWeight:600 }}>Catégorie vide</div>
                      <div style={{ fontSize:12, marginTop:6, color:'#475569' }}>Utilisez « ➕ Ajouter des chaînes » pour en ajouter depuis d'autres catégories.</div>
                    </div>
                  )}
                </div>
              ) : filteredCh.map((ch, i) => (
                <div key={ch.id}
                  style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 18px', borderBottom:'1px solid #1e293b30', background: selected.has(ch.id) ? '#f59e0b10' : i%2===0 ? 'transparent' : '#0f172a50', borderLeft: selected.has(ch.id) ? '3px solid #f59e0b' : '3px solid transparent', transition:'background 0.1s' }}
                  onMouseEnter={e => { if(!selected.has(ch.id)) e.currentTarget.style.background='#6366f115'; }}
                  onMouseLeave={e => { if(!selected.has(ch.id)) e.currentTarget.style.background= selected.has(ch.id) ? '#f59e0b10' : i%2===0 ? 'transparent' : '#0f172a50'; }}>
                  <input type="checkbox" checked={selected.has(ch.id)} onChange={() => toggleSel(ch.id)}
                    style={{ width:16, height:16, accentColor:'#f59e0b', cursor:'pointer', flexShrink:0 }} />
                  <div style={{ width:32, height:32, flexShrink:0, borderRadius:6, overflow:'hidden', background:'#1e293b', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14 }}>
                    {ch.stream_icon ? <img src={ch.stream_icon} alt="" style={{ width:'100%', height:'100%', objectFit:'contain' }} onError={e => e.target.style.display='none'} /> : '📺'}
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:13, fontWeight:500, color: ch.is_active===0 ? '#64748b' : '#e2e8f0', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                      {ch.is_active===0 && <span style={{ marginRight:4, fontSize:10, color:'#ef4444' }}>🚫</span>}{ch.name}
                    </div>
                    <div style={{ fontSize:10, color:'#475569', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', marginTop:1 }}>{ch.stream_url||'—'}</div>
                  </div>
                  <span style={{ fontSize:10, color:'#334155', flexShrink:0 }}>#{ch.stream_id}</span>
                  <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                    <button onClick={() => setEditing(ch)} style={{ padding:'5px 12px', borderRadius:6, border:'1px solid #6366f150', background:'#6366f115', color:'#818cf8', cursor:'pointer', fontSize:12, fontWeight:600 }}>✏️ Modifier</button>
                    <button onClick={() => handleDelete(ch)} disabled={deleting===ch.id} style={{ padding:'5px 12px', borderRadius:6, border:'1px solid #ef444450', background:'#ef444415', color:'#f87171', cursor:deleting===ch.id?'not-allowed':'pointer', fontSize:12, fontWeight:600, opacity:deleting===ch.id?0.5:1 }}>
                      {deleting===ch.id ? '⏳' : '🗑️ Supprimer'}
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {totalPages > 1 && (
              <div style={{ padding:'12px 18px', borderTop:'1px solid #1e293b', background:'#0f172a', display:'flex', alignItems:'center', justifyContent:'center', gap:12, flexWrap:'wrap' }}>
                <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page <= 1 || loadingCh}
                  title="Page précédente"
                  style={{ width:34, height:32, borderRadius:6, border:'1px solid #334155', background:'#1e293b', color:'#cbd5e1', cursor:(page<=1||loadingCh)?'not-allowed':'pointer', opacity:(page<=1||loadingCh)?0.4:1, fontSize:18 }}>
                  ‹
                </button>
                <span style={{ color:'#94a3b8', fontSize:12, minWidth:150, textAlign:'center' }}>
                  Page <strong style={{ color:'#e2e8f0' }}>{page.toLocaleString()}</strong> sur {totalPages.toLocaleString()}
                </span>
                <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page >= totalPages || loadingCh}
                  title="Page suivante"
                  style={{ width:34, height:32, borderRadius:6, border:'1px solid #334155', background:'#1e293b', color:'#cbd5e1', cursor:(page>=totalPages||loadingCh)?'not-allowed':'pointer', opacity:(page>=totalPages||loadingCh)?0.4:1, fontSize:18 }}>
                  ›
                </button>
              </div>
            )}
          </div>
        ) : !loadingCats && (
          <div style={{ padding:60, textAlign:'center', color:'#475569', background:'#111827', borderRadius:12, border:'1px solid #1e293b' }}>
            <div style={{ fontSize:40, marginBottom:12 }}>📁</div>
            <div style={{ fontSize:15, fontWeight:600, color:'#64748b' }}>Sélectionnez une catégorie</div>
            <div style={{ fontSize:13, marginTop:6 }}>Choisissez un provider puis une catégorie dans la liste ci-dessus.</div>
          </div>
        )}

        {editing && <EditModal channel={editing} categories={allCategories} onSave={handleSaved} onClose={() => setEditing(null)} />}
        <Toast msg={toast?.msg} ok={toast?.ok} onClose={() => setToast(null)} />
      </div>
    </AdminLayout>
  );
}
